"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS = void 0;
var PRODUCTS = {
  INPUT__SEARCH: 'newPendingUpdateProducts-input-search',
  LABEL__PRODUCT_CHECKBOX: 'newPendingUpdateProducts-label-productCheckbox',
  TEXT__PRODUCT_NAME: 'newPendingUpdateProducts-span-productName',
  TEXT__PRODUCT_SKU: 'newPendingUpdateProducts-span-productSKU',
  BUTTON__CREATE_NEW_PRODUCT: 'newPendingUpdateProducts-button-newProduct',
  BUTTON__UPLOAD_CSV: 'newPendingUpdateProducts-button-uploadCSV',
  NEW_PRODUCT: {
    INPUT__COGS: 'newPendingUpdateNewProduct-input-cogs',
    INPUT__PRICE: 'newPendingUpdateNewProduct-input-price',
    INPUT__MINIMUM_QUANTITY: 'newPendingUpdateNewProduct-input-minimumQuantity',
    INPUT__QUANTITY_INCREMENT: 'newPendingUpdateNewProduct-input-quantityIncrement',
    BUTTON__SALES_UNIT: 'newPendingUpdateNewProduct-button-salesUnit',
    BUTTON__PRICE_UNIT: 'newPendingUpdateNewProduct-button-priceUnit',
    LABEL__MARKET_PRICE: 'newPendingUpdateNewProduct-label-marketPrice',
    LABEL__PRICE_UNIT: 'newPendingUpdateNewProduct-label-priceUnit',
    BUTTON__ADD_IMAGE: 'newPendingUpdateNewProduct-button-addImage',
    BUTTON__REMOVE_IMAGE: 'newPendingUpdateNewProduct-button-removeImage',
    INPUT__NAME: 'newPendingUpdateNewProduct-input-name',
    INPUT__SKU: 'newPendingUpdateNewProduct-input-sku',
    BUTTON__CATEGORY: 'newPendingUpdateNewProduct-button-category',
    TEXTAREA__DESCRIPTION: 'newPendingUpdateNewProduct-textarea-description',
    BUTTON__CANCEL: 'newPendingUpdateNewProduct-button-cancel',
    BUTTON__CREATE: 'newPendingUpdateNewProduct-button-create'
  },
  SELECTED_PRODUCTS: {
    TEXT__NAME: 'newPendingUpdateSelectedProducts-span-name',
    TEXT__SKU: 'newPendingUpdateSelectedProducts-span-sku',
    INPUT__PRICE: 'newPendingUpdateSelectedProducts-input-price',
    TEXT__UNIT: 'newPendingUpdateSelectedProducts-span-unit',
    INPUT__QUANTITY: 'newPendingUpdateSelectedProducts-input-quantity',
    INPUT__AMOUNT: 'newPendingUpdateSelectedProducts-input-amount',
    BUTTON__REMOVE: 'newPendingUpdateSelectedProducts-button-remove'
  }
};
exports.PRODUCTS = PRODUCTS;